module.exports = __webpack_public_path__ + "img/white-cam-3.da6c53f3.png";